import React from 'react';

const Button = ({children, get_data}) => {
    return (
        <div className={'flex justify-center mt-8'}>
            <button onClick={() => get_data()} className={'bg-amber-500 text-white px-4 py-2 hover:scale-110 duration-200'}>{children}</button>
        </div>
    );
};

export default Button;